export default __webpack_public_path__ + "static/media/logo.ddef8621.svg";